import { RouteConfig } from "vue-router";

import { Network } from "@/network";

const HomeRoute: Array<RouteConfig> = [
  {
    path: "/",
    component: () => import("@/views/ap/home/Index.vue"),
    beforeEnter: async (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },

  //20230213 以下新增
  {
    path: "/news",
    name: "news",
    component: () => import("@/views/ap/home/News.vue"),
    beforeEnter: async (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },
];

export { HomeRoute };
